<div echarts [options]="echartPPUBarOptions" style="height: 330px"></div>